import { createFallbackMonitoringClient } from '@wix/monitoring'
import { createSentryBrowserClient, CreateSentryBrowserClientOptions } from '@wix/monitoring-browser-sentry'
import type { HostMonitoringContext } from '@wix/monitoring-types'
import type { AppWithMonitoring, BrowserWindow } from '@wix/thunderbolt-symbols'
import type { GetMonitoringClientFunction } from './types'

const getHostMonitoringContext = ({
	appId,
	metaSiteId,
	siteUrl,
}: {
	appId: string
	metaSiteId?: string
	siteUrl?: string
}): HostMonitoringContext => ({
	appId,
	platform: 'SITE_VIEWER',
	tenantType: 'SITE',
	tenantId: metaSiteId,
	siteUrl,
})

export const getMonitoringClientFunctionFactory = ({
	config,
	sentry,
	sentryTransport,
}: {
	config?: AppWithMonitoring
	sentry?: NonNullable<BrowserWindow>['Sentry']
	sentryTransport?: CreateSentryBrowserClientOptions['transport'] // for tests
}): GetMonitoringClientFunction => ({ appId, metaSiteId, siteUrl }) => {
	const { type, sentryOptions } = config?.monitoringComponent?.monitoring || {}

	if (type !== 'SENTRY') {
		return () =>
			createFallbackMonitoringClient(
				'Invalid monitoring configuration. Please check the monitoring setup of your application.'
			)
	}

	return () =>
		createSentryBrowserClient({
			microFrontendEnvironment: true,
			dsn: sentryOptions?.dsn,
			hostContext: getHostMonitoringContext({ appId, metaSiteId, siteUrl }),
			sentrySDK: sentry as any,
			transport: sentryTransport,
		})
}
